import { Field, useForm, useFormState } from 'react-final-form';
import { RenderIf } from 'react-rainbow-components';
import { UniversalPickerOption } from '@rainbow-modules/forms';
import { validateNotEmpty } from 'data/validators';
import { FieldsContainer, StyledInput, StyledUniversalPicker } from './styled';
import RadioItem from './radioItem';

const Fields = () => {
    const { values, initialValues } = useFormState();
    const { change } = useForm();
    const { override, id } = values;
    const overrideValue = override || (id ? 'yes' : 'no');
    return (
        <FieldsContainer>
            <RenderIf isTrue={!!id}>
                <StyledUniversalPicker
                    name="override"
                    value={overrideValue}
                    onChange={(value: any) => change('override', value)}
                    direction="vertical"
                >
                    <UniversalPickerOption component={RadioItem} name="yes">
                        Overwrite
                        {' '}
                        <b>{initialValues.title}</b>
                        ?
                    </UniversalPickerOption>
                    <UniversalPickerOption component={RadioItem} name="no">
                        Create a new input
                    </UniversalPickerOption>
                </StyledUniversalPicker>
            </RenderIf>
            <RenderIf isTrue={overrideValue === 'no'}>
                <Field
                    name="title"
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={StyledInput}
                    label="Enter title"
                    labelAlignment="left"
                    borderRadius="semi-square"
                    required
                    validate={validateNotEmpty('Required')}
                />
            </RenderIf>
        </FieldsContainer>
    );
};

export default Fields;
